// ----------------------------------------------------------------------

export default function Slider() {
  return {
    MuiSlider: {
      styleOverrides: {
        mark: {
          background: 'transparent'
        },
        markActive: {
          background: 'transparent'
        }
      }
    }
  };
}
